(function() {
  "use strict";

  angular.module("humbertContainer").config(configure);

  configure.$inject = ["$urlRouterProvider", "$stateProvider"];

  function configure($urlRouterProvider, $stateProvider) {
    $urlRouterProvider
      //.when('/container', '/container/anfrage')
      .otherwise("/anfrage");

    $stateProvider
      .state("form", {
        url: "/anfrage",
        templateUrl:
          "/wp-content/plugins/humbert-apps/public/humbert-gmbh/humbert/service/container/app/container/container-form.html",
        controller: "ContainerFormController",
        controllerAs: "vm"
      })
      .state("calc", {
        url: "/rechner?fractionKey&containerTypeKey&to&freightZoneKey",
        params: {
          fractionKey: {
            value: "",
            dynamic: true
          },
          containerTypeKey: {
            value: "",
            dynamic: true
          },
          to: {
            value: "",
            dynamic: true
          },
          freightZoneKey: {
            value: "",
            dynamic: true
          }
        },
        templateUrl:
          "/wp-content/plugins/humbert-apps/public/humbert-gmbh/humbert/service/container/app/container/container-calc.html",
        controller: "ContainerCalcController",
        controllerAs: "vm"
      });
  }
})();
